import { createContext, useContext, Dispatch, SetStateAction } from 'react';

type SharingModalContextType = {
    isSharingModalOpen: boolean;
    setIsSharingModalOpen: Dispatch<SetStateAction<boolean>>;
};

const initialContext = {
    isSharingModalOpen: false,
    setIsSharingModalOpen: () => {},
};

const SharingModalContext =
    createContext<SharingModalContextType>(initialContext);
const useSharingModalContext = () => useContext(SharingModalContext);

export { useSharingModalContext, SharingModalContext };
